import { combineEpics } from "redux-observable";
import { epicThemedEventBuildingClicked } from "./epicThemedEventBuildingClicked";
import { epicThemedEventCollectReward } from "./epicThemedEventCollectReward";
import { epicThemedEventFinish } from "./epicThemedEventFinish";
import { epicThemedEventLoadBuilding } from "./epicThemedEventLoadBuilding";
import { epicThemedEventRewardCollected } from "./epicThemedEventRewardCollected";
import { epicThemedEventStart } from "./epicThemedEventStart";
import { epicThemedEventTimeStart } from "./epicThemedEventTimeStart";
export var epicThemedEvent = combineEpics(epicThemedEventStart, epicThemedEventBuildingClicked, epicThemedEventFinish, epicThemedEventCollectReward, epicThemedEventRewardCollected, epicThemedEventLoadBuilding, epicThemedEventTimeStart);



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/epics/epicThemedEvent.ts
// module id = 2420
// module chunks = 3